import { useEffect } from 'react'
import TenantBar from './TenantBar.jsx'
import MenuButton from './MenuButton.jsx'
import UserBar from './UserBar.jsx'
import NotificationBar from './NotificationBar.jsx'

const HeaderNavBar = ({ openMenu, setOpenMenu, companiesList, branchesList, tenantUsername, tenant, companySelected, branchSelected }) => {
    useEffect(() => {
        const headerElement = document.querySelector('.primary-bg-color.sticky')
        if (!headerElement) return
        const update = () => {
            document.documentElement.style.setProperty('--header-height', `${headerElement.offsetHeight}px`)
        }
        update()
        const observer = new ResizeObserver(update)
        observer.observe(headerElement)
        return () => observer.disconnect()
    }, [])
    return (
        <>
            <div className='primary-bg-color  sticky top-0 z-50 text-white'>
                <NotificationBar />
                <div className="px-3 py-1 m-auto  w-full px-1">
                    <div className='flex flex-col md:flex-row  w-full  justify-between items-center '>
                        <div className='flex items-center justify-between w-full '>

                            <TenantBar
                                companiesList={companiesList}
                                branchesList={branchesList}
                                companySelected={companySelected}
                                branchSelected={branchSelected} />
                        </div>
                        <a href='https://apps.absat-erp.com/' target='_blank' rel='noreferrer' className='m-auto'>
                            <img style={{ width: '90px' }}src='https://finance.absat-erp.com/logo-white.webp' alt='Absat' />
                        </a>
                        <UserBar
                            tenantUsername={tenantUsername}
                            tenant={tenant}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default HeaderNavBar 
